import { render } from "./FlowIndex.vue?vue&type=template&id=4e46ef88"
import script from "./FlowIndex.vue?vue&type=script&lang=js"
export * from "./FlowIndex.vue?vue&type=script&lang=js"
script.render = render

export default script